<!-- HERO BANNER SECTION -->
<section
    class="relative bg-gradient-to-b from-[#102B51] via-[#163564] to-[#0D2240] text-white py-16 md:py-24 overflow-hidden">
    <!-- Decorative Ambient Glows -->
    <div class="absolute -top-24 -left-24 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute top-1/2 -right-24 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl pointer-events-none"></div>

    <div class="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div class="text-center max-w-3xl mx-auto space-y-4">
            <h1 class="text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight text-white leading-tight">
                Smart Ticketing & <span class="text-emerald-400">QR Gate System</span>
            </h1>
            <p class="text-gray-300 text-sm md:text-lg leading-relaxed max-w-2xl mx-auto">
                Sistem tiket digital bebas antre dari Visidea Studio,
                hadirkan validasi QR Code kilat, gerbang turnstile
                otomatis, serta rekapitulasi data pengunjung real-time
                buat segala skala acara.
            </p>
        </div>
    </div>
</section>

<!-- 2 CATEGORIES SELECTION GRID -->
<section class="py-12 md:py-16 px-4 sm:px-6 md:px-12 bg-[#F8FAFC] relative">
    <div class="max-w-5xl mx-auto">

        <!-- Section Title -->
        <div class="text-center max-w-2xl mx-auto mb-10 space-y-2">
            <h2 class="text-xs font-bold tracking-widest text-[#202367] uppercase mb-1">
                PILIHAN KATEGORI SMART TICKETING
            </h2>
            <h3 class="text-2xl sm:text-3xl font-extrabold text-[#102B51] tracking-tight">
                Sistem Tiket & Gate Access Terintegrasi
            </h3>
            <p class="text-xs sm:text-sm text-slate-500">
                Pilih paket sistem ticketing yang paling pas buat
                kebutuhan dan skala event kamu
            </p>
        </div>

        <!-- Cards Grid: Basic vs Premium (Compact & Sleek) -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">

            <div *ngFor="let cat of categories; let i = index"
                class="group bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col hover:-translate-y-1.5 relative">

                <!-- Badge (Top-Right) -->
                <div class="absolute top-3.5 right-3.5 z-20">
                    <span [ngClass]="cat.badgeColor"
                        class="text-white text-[10px] sm:text-xs font-bold px-3 py-1 rounded-full shadow-md uppercase tracking-wider">
                        {{ cat.badge }}
                    </span>
                </div>

                <!-- Product Image Cover (Compact Height) -->
                <div class="relative h-48 sm:h-56 md:h-60 overflow-hidden">
                    <img [src]="cat.image" [alt]="cat.name"
                        class="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500">
                    <div class="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent"></div>

                    <div class="absolute bottom-3.5 left-4 right-4 text-white">
                        <h4
                            class="text-lg sm:text-xl font-bold text-white drop-shadow-sm group-hover:text-emerald-200 transition-colors">
                            {{ cat.name }}
                        </h4>
                    </div>
                </div>

                <!-- Product Card Body -->
                <div class="p-5 sm:p-6 flex-1 flex flex-col justify-between">
                    <div>
                        <!-- Pricing Section -->
                        <div class="flex items-baseline justify-between mb-3 pb-3 border-b border-gray-100">
                            <div>
                                <span class="text-[11px] text-gray-400 block font-medium">Mulai dari</span>
                                <div class="flex items-baseline gap-2">
                                    <span class="text-xl sm:text-2xl font-extrabold text-[#102B51]">
                                        {{ cat.priceFormatted }}
                                    </span>
                                    <span *ngIf="cat.originalPriceFormatted" class="text-xs text-gray-400 line-through">
                                        {{ cat.originalPriceFormatted }}
                                    </span>
                                </div>
                            </div>
                            <div class="text-right">
                                <span
                                    class="text-[10px] font-semibold text-slate-400 block uppercase tracking-wider">Kapasitas</span>
                                <span class="text-xs sm:text-sm font-bold text-emerald-600">
                                    {{ cat.capacity }}
                                </span>
                            </div>
                        </div>

                        <!-- Short Description -->
                        <p class="text-gray-600 text-xs leading-relaxed mb-3.5 line-clamp-2 font-normal">
                            {{ cat.description }}
                        </p>

                        <!-- Key Feature Highlights -->
                        <div class="space-y-2 mb-4">
                            <!-- First 4 features -->
                            <div *ngFor="let feat of cat.features.slice(0, 4)"
                                class="flex items-start gap-2 text-xs text-gray-700">
                                <span
                                    class="w-3.5 h-3.5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center flex-shrink-0 mt-0.5 font-bold text-[9px]">
                                    ✓
                                </span>
                                <span class="leading-tight">{{ feat }}</span>
                            </div>

                            <!-- Expandable Show More Features & Details -->
                            <ng-container *ngIf="cat.showMore">
                                <div *ngFor="let feat of cat.features.slice(4)"
                                    class="flex items-start gap-2 text-xs text-gray-700 animate-fade-in">
                                    <span
                                        class="w-3.5 h-3.5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center flex-shrink-0 mt-0.5 font-bold text-[9px]">
                                        ✓
                                    </span>
                                    <span class="leading-tight">{{ feat }}</span>
                                </div>

                                <!-- Full Description if available -->
                                <div *ngIf="cat.longDescription"
                                    class="mt-3 text-xs text-gray-600 bg-slate-50 p-3 rounded-2xl border border-slate-100 animate-fade-in">
                                    <span class="font-bold text-[#102B51] block mb-1">Deskripsi Layanan:</span>
                                    <p class="leading-relaxed">{{ cat.longDescription }}</p>
                                </div>

                                <!-- Deliverables if available -->
                                <div *ngIf="cat.deliverables && cat.deliverables.length > 0"
                                    class="mt-3 space-y-1.5 animate-fade-in">
                                    <span class="text-[11px] font-bold uppercase tracking-wider text-slate-400 block">Deliverables Termasuk:</span>
                                    <div *ngFor="let deliv of cat.deliverables"
                                        class="flex items-start gap-2 text-xs text-gray-700 bg-blue-50/50 p-2.5 rounded-xl border border-blue-100/60">
                                        <span class="text-[#202367] font-bold">📌</span>
                                        <span class="leading-tight font-medium">{{ deliv }}</span>
                                    </div>
                                </div>

                                <!-- Hardware & Equipment if available -->
                                <div *ngIf="cat.hardwareIncluded && cat.hardwareIncluded.length > 0"
                                    class="mt-3 space-y-1.5 animate-fade-in">
                                    <span class="text-[11px] font-bold uppercase tracking-wider text-slate-400 block">Hardware & Infrastruktur:</span>
                                    <ul class="space-y-1.5 text-xs text-gray-600">
                                        <li *ngFor="let eq of cat.hardwareIncluded" class="flex items-center gap-2">
                                            <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                                            <span>{{ eq }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="space-y-2 pt-3.5 border-t border-gray-100">
                        <!-- Toggle Show More Button -->
                        <button type="button" (click)="toggleShowMore(cat, $event)"
                            class="w-full py-2 text-xs font-semibold text-[#102B51] hover:text-[#202367] bg-slate-50 hover:bg-slate-100 rounded-xl transition flex items-center justify-center gap-1.5 cursor-pointer">
                            <span>{{ cat.showMore ? 'Tutup Detail' : 'Lihat Detail Lengkap' }}</span>
                            <svg class="w-3.5 h-3.5 transition-transform duration-200" [class.rotate-180]="cat.showMore"
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>

                        <div class="grid grid-cols-2 gap-2">
                            <!-- Add to Cart Button -->
                            <button (click)="addToCart(cat, $event)"
                                class="w-full py-2.5 px-3 bg-white hover:bg-emerald-50 text-emerald-700 border border-emerald-600 font-semibold rounded-xl transition-all duration-200 text-xs flex items-center justify-center gap-1.5 shadow-sm active:scale-95 cursor-pointer">
                                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                <span>Keranjang</span>
                            </button>

                            <!-- Checkout Button -->
                            <button (click)="checkout(cat, $event)"
                                class="w-full py-2.5 px-3 bg-gradient-to-r from-[#202367] to-[#102B51] hover:from-[#191c53] hover:to-[#091b33] text-white font-semibold rounded-xl transition-all duration-200 text-xs flex items-center justify-center gap-1.5 shadow-md hover:shadow-lg active:scale-95 cursor-pointer">
                                <span>Checkout</span>
                                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </button>
                        </div>

                        <!-- WhatsApp Quick Consultation -->
                        <button (click)="openConsultationModal(cat)"
                            class="w-full py-2 px-3 rounded-xl bg-emerald-50 hover:bg-emerald-100/70 text-emerald-700 font-bold text-xs transition-all flex items-center justify-center gap-1.5 cursor-pointer">
                            <span>Konsultasi Khusus & Proposal</span>
                        </button>
                    </div>
                </div>

            </div>

        </div>

    </div>
</section>

<!-- CONSULTATION MODAL -->
<div *ngIf="isConsultationModalOpen"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-[#0A0E1A]/70 backdrop-blur-sm animate-fade-in"
    (click)="closeConsultationModal()">

    <div class="relative w-full max-w-xl bg-white rounded-3xl p-6 sm:p-8 shadow-2xl border border-slate-100 overflow-hidden max-h-[90vh] overflow-y-auto"
        (click)="$event.stopPropagation()">

        <!-- Top Accent Line -->
        <div class="absolute top-0 inset-x-0 h-1.5 bg-gradient-to-r from-[#202367] via-emerald-500 to-[#102B51]"></div>

        <!-- Close Button -->
        <button (click)="closeConsultationModal()" aria-label="Tutup"
            class="absolute top-5 right-5 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 hover:text-slate-800 flex items-center justify-center transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>

        <!-- Header -->
        <div class="mb-6 pr-8">
            <div
                class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-[#1E3A8A] text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2">
                <span>Smart Ticketing Consultation</span>
            </div>
            <h3 class="text-xl sm:text-2xl font-black text-[#102B51] tracking-tight">
                Konsultasi & Penawaran Smart Ticketing
            </h3>
            <p class="text-xs sm:text-sm text-slate-500 mt-1 leading-relaxed">
                Isi form singkat ini dan tim technical event Visidea akan menyiapkan proposal teknis serta estimasi
                biaya yang paling efisien.
            </p>
        </div>

        <form (ngSubmit)="submitConsultation()" class="space-y-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Nama Acara / Event <span class="text-rose-500">*</span>
                    </label>
                    <input type="text" [(ngModel)]="consultationForm.eventName" name="eventName" required
                        placeholder="Cth: Soundfest 2026 / Seminar Nasional"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Pilihan Kategori
                    </label>
                    <select [(ngModel)]="consultationForm.packageInterest" name="packageInterest"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition bg-white">
                        <option value="Smart Ticketing Basic">Smart Ticketing Basic</option>
                        <option value="Smart Ticketing Premium">Smart Ticketing Premium</option>
                    </select>
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Tanggal Acara
                    </label>
                    <input type="date" [(ngModel)]="consultationForm.eventDate" name="eventDate"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Estimasi Pengunjung / Peserta
                    </label>
                    <select [(ngModel)]="consultationForm.expectedAttendees" name="expectedAttendees"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition bg-white">
                        <option value="< 500 Peserta">
                            < 500 Peserta</option>
                        <option value="500 - 1.000 Peserta">500 - 1.000 Peserta</option>
                        <option value="1.000 - 5.000 Peserta">1.000 - 5.000 Peserta</option>
                        <option value="> 5.000 Peserta (Festival/Konser)">> 5.000 Peserta (Festival/Konser)</option>
                    </select>
                </div>
            </div>

            <div>
                <label class="block text-xs font-bold text-slate-700 mb-1.5">
                    Lokasi / Venue Acara
                </label>
                <input type="text" [(ngModel)]="consultationForm.eventLocation" name="eventLocation"
                    placeholder="Cth: Hall Convention Center Jakarta / Lapangan Parkir Timur"
                    class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 border-t border-slate-100">
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Nama Kontak
                    </label>
                    <input type="text" [(ngModel)]="consultationForm.contactName" name="contactName"
                        placeholder="Nama penanggung jawab"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        No. WhatsApp Kontak <span class="text-rose-500">*</span>
                    </label>
                    <input type="tel" [(ngModel)]="consultationForm.contactPhone" name="contactPhone" required
                        placeholder="08xxxxxxxxxx"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>
            </div>

            <div>
                <label class="block text-xs font-bold text-slate-700 mb-1.5">
                    Kebutuhan Khusus / Catatan
                </label>
                <textarea [(ngModel)]="consultationForm.notes" name="notes" rows="2"
                    placeholder="Cth: Butuh turnstile 4 jalur, gelang RFID custom logo, barcode tiket offline..."
                    class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition resize-none"></textarea>
            </div>

            <div class="flex items-center gap-3 pt-4">
                <button type="button" (click)="closeConsultationModal()"
                    class="py-3 px-5 rounded-xl border border-slate-200 hover:bg-slate-50 text-slate-600 text-xs sm:text-sm font-semibold transition cursor-pointer">
                    Batal
                </button>
                <button type="submit"
                    class="flex-1 py-3 px-5 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-xs sm:text-sm tracking-wide flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all active:scale-[0.99] cursor-pointer">
                    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                    <span>Kirim & Buka WhatsApp</span>
                </button>
            </div>
        </form>

    </div>
</div>